import Vue from 'vue';
import Vuex from 'vuex';
import { online_student_status, offline_student_status, branch_office, cooperation, identity, follow_status } from '@/module/select.ts';
Vue.use(Vuex);
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  get_tag_list: `${FCAPI}/boss/hundun/setting/tag/search`,
  get_teacher_list: `${FCAPI}/boss/hundun/setting/teacher/search`
};
const state = {
  online_student_status: online_student_status,
  offline_students_status: offline_student_status,
  branch_office: branch_office,
  cooperation_selects: cooperation,
  identity: identity,
  follow_status: follow_status,
  tag_list: [],
  teacher_list: []
};
const mutations = {
  ['get_tags'](state: any, data: any) {
    state.tag_list = data;
  },
  ['get_teacher'](state: any, data: any) {
    state.teacher_list = data;
  }
};

const actions = {
  async FETCH_TAGS({ commit }: any) {
    const res: any = await Vue.prototype.$axios(API.get_tag_list, { params: { is_all: 1 } });
    if (res.status === 200) {
      res.data.data.push({ id: -1, tag_name: '无' });
      const new_list = (list: any) => {
        for (const i in list) {
          if (list[i].parent) {
            if (list[i].parent.length == 0) delete list[i].parent;
            new_list(list[i].parent);
          }
        }
      };
      new_list(res.data.data);
      commit('get_tags', res.data.data);
    }
  },
  async FETCH_TEACHER({ commit }: any) {
    const res: any = await Vue.prototype.$axios(API.get_teacher_list, {
      params: { is_all: 1 }
    });
    if (res.status === 200) {
      res.data.data.unshift({ id: 0, weixin_nickname: '全部' });
      res.data.data.push({ id: -1, weixin_nickname: '无' });
      commit('get_teacher', res.data.data);
    }
  }
};
const getters = {
  ['online_student_status'](state: any) {
    return state.online_student_status;
  },
  ['offline_students_status'](state: any) {
    return state.offline_students_status;
  },
  ['branch_office'](state: any) {
    return state.branch_office;
  },
  ['cooperation_selects'](state: any) {
    return state.cooperation_selects;
  },
  ['identity'](state: any) {
    return state.identity;
  },
  ['follow_status'](state: any) {
    return state.follow_status;
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
